module.exports = __webpack_public_path__ + "img/59ne.fa6e652f.svg";